//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import DJAreaSideMenu from './sidemenu';
import Share from '../components/share/share';
import Gallery from 'react-photo-gallery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';
import axios from 'axios';
import {Text} from 'react-native';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ButtonGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import ProgressBar from 'react-bootstrap/ProgressBar';

import './css/seo.css';

export default class AdminSEO extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,

			seo: [],
			share: false,

			images: [],
			edit: -1,
			seo_edit: {
				url: '/',
				title: '',
				description: '',
				image: '',
				frequency: 'daily',
				priority: '0.5',
			},

			filename: '',
			percent: 0,

			error: '',

		};
		this.getSeo = this.getSeo.bind(this);
		this.editSeo = this.editSeo.bind(this);
		this.share = this.share.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.submitEvent = this.submitEvent.bind(this);
		this.renderImage = this.renderImage.bind(this);
		this.selectImage = this.selectImage.bind(this);
		this.clickuploadFile = this.clickuploadFile.bind(this);
		this.uploadFile = this.uploadFile.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		await this.getSeo();

	}

	componentWillUnmount() {
	}

	async getSeo() {
		var params = new URLSearchParams();
		const x = await postApi('/api/v2/admin/seo', params);
		this.setState({status: true, seo: x.data.seo, images: x.data.images});
	}

	editSeo(id){
		console.log(id);
		let seo_edit = {
			url: '/',
			title: '',
			description: '',
			image: '',
			frequency: 'daily',
			priority: '0.5',
		};
		if( id > 0 ) {
			for( let i in this.state.seo ) {
				if( this.state.seo[i].id === id ) {
					console.log(this.state.seo[i].image.replace("/images/seo/",""));
					seo_edit = {
						url: this.state.seo[i].location,
						title: this.state.seo[i].title,
						description: this.state.seo[i].description,
						image: this.state.seo[i].image.replace("/images/seo/",""),
						frequency: this.state.seo[i].changefreq,
						priority: this.state.seo[i].priority,
					};
				}
			}
		}
		if( id === this.state.edit )
			this.setState({edit: -1, seo_edit});
		else
			this.setState({edit: id, seo_edit});
	}

	share(e) {
		this.setState({share: e.toLowerCase()});
	}
	close = (childData) => {
    this.setState({share: false});
	}
	
	handleChange(event) {
		let item = event.target.value;
		let seo_edit = this.state.seo_edit;
		if( event.target.name === "url" ) seo_edit.url = item;
		if( event.target.name === "title" ) seo_edit.title = item;
		if( event.target.name === "description" ) seo_edit.description = item;
		if( event.target.name === "image" ) seo_edit.image = item;
		if( event.target.name === "frequency" ) seo_edit.frequency = item;
		if( event.target.name === "priority" ) seo_edit.priority = item;
		this.setState({seo_edit});
	}

	async submitEvent(e) {
		e.preventDefault();
		console.log("submit!");
		
		let params = new URLSearchParams();
		params.append('id', this.state.edit);
		params.append('url', this.state.seo_edit.url);
		params.append('title', this.state.seo_edit.title);
		params.append('description', this.state.seo_edit.description);
		params.append('image', this.state.seo_edit.image);
		params.append('frequency', this.state.seo_edit.frequency);
		params.append('priority', this.state.seo_edit.priority);

		const x = await putApi('/api/v2/admin/seo', params);
		console.log(x.status, x.data);
		if( x.status === 200 ) {
			await this.getSeo();
			this.setState({edit: -1});
		} else {
			this.setState({error: x.data});
		}

	}

	renderImage(index, left, top, key, photo) {
		return(
			<div className="" key={index.index} style={{margin: index.margin, cursor: 'pointer', position: 'relative', float: 'left'}}>
				<img src={index.photo.src} width={index.photo.width} height={index.photo.height} style={{}} onClick={()=>this.selectImage(index.photo.filename)} />
				<Button size="sm" onClick={()=>this.deleteImage(index.photo.filename)} style={{position: 'absolute', left: 2, bottom: 2, backgroundColor: 'rgb(33,37,41) !important', padding: '2px 4px'}}>
					<FontAwesomeIcon icon="trash" />
				</Button>
				
			</div>
		)
	}
	selectImage(event) {
		let seo_edit = this.state.seo_edit;
		seo_edit.image = event;
		this.setState({seo_edit});
	}


	clickuploadFile(e) {
		document.getElementById('upload').click();
	}
	async uploadFile(event) {
		if( event.target.files[0] ) {
			this.setState({filename: event.target.files[0].name});
			const params = new FormData();
			params.append('file', event.target.files[0]);
			axios.put('/api/v2/admin/seo/images', params, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				withCredentials: true,
				onUploadProgress: (progressEvent) => {
					let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
					this.setState({percent: percentCompleted});
				}
			})
			.then(res => {
				switch(res.status) {
					case 200:
						//this.props.complete();
						let seo_edit = this.state.seo_edit;
						seo_edit.image = res.data.image;
						this.setState({percent: 0, images: res.data.images, seo_edit});
						break;
					default:
						this.setState({filename: res.data.message, percent: 0});
						break;
				}
			})
		}
	}

	async deleteImage(src) {
		if( window.confirm("Are you sure you wish to delete this image?" ) ) {
			var params = new URLSearchParams();
			params.append('image', src);
			let x = await deleteApi('/api/v2/admin/seo/images',params);
			if( x.status === 200 ) {
				let seo_edit = this.state.seo_edit;
				if( seo_edit.image === src ) seo_edit.image = '';
				this.setState({images:x.data.images, seo_edit});
			}
		}
	}


	render() {
		const seo = 
      Object.keys(this.state.seo).map((e,i) => {
        return (
					<div key={i} className="card bg-dark">
						{this.state.edit === this.state.seo[e].id ?
							<>
								<Form id="edit" onSubmit={this.submitEvent}>
									<div className="card-header">
										<h3 className="card-title">Edit SEO Entry</h3>
										<div className="card-tools">
										</div>
									</div>
									<div className="card-body admin-seo">
										<Row className="py-1 gx-0">
											<Col>

												<div className="form-group row pt-1 pb-0 mb-1">
													<label htmlFor="url" className="col-sm-3 col-form-label col-form-label-sm ps-4">
														<strong>URL</strong><br />
													</label>
													<div className="col-md-6 mt-2">
														<Form.Control form="edit" type="text" name="url" id="url" value={this.state.seo_edit.url} onChange={this.handleChange} placeholder="Website Url" />
														<small>Please exclude the domain name and start from the first forward slash.</small>
													</div>
												</div>

												<div className="form-group row pt-1 pb-0 mb-1">
													<label htmlFor="title" className="col-sm-3 col-form-label col-form-label-sm ps-4">
														<strong>Title</strong><br />
													</label>
													<div className="col-md-6 mt-2">
														<Form.Control form="edit" type="text" name="title" id="title" value={this.state.seo_edit.title} onChange={this.handleChange} placeholder="Website Title" />
													</div>
												</div>

												<div className="form-group row pt-1 pb-0 mb-1">
													<label htmlFor="description" className="col-sm-3 col-form-label col-form-label-sm ps-4">
														<strong>Description</strong><br />
													</label>
													<div className="col-md-8 mt-2">
														<Form.Control form="edit" as="textarea" name="description" id="description" rows={5} value={this.state.seo_edit.description} onChange={this.handleChange} placeholder="Website Description" />
													</div>
												</div>
												
												<div className="form-group row pt-1 pb-0 mb-1">
													<label htmlFor="image" className="col-sm-3 col-form-label col-form-label-sm ps-4">
														<strong>Image</strong><br />
													</label>
													<div className="col-md-8 mt-2">
														<Row>
															<Col xs={3} className="admin-seo-selected">
																<img src={`https://mix365.co.uk/images/seo/${this.state.seo_edit.image}`} className="admin-seo-selected-image" alt="No Image Selected" />
															</Col>
															<Col xs={9}>
																<Row onClick={(f)=>this.clickuploadFile(f)} style={{cursor: 'pointer'}}>
																	<Col xs={3} className="upload-file-outer">
																		<div className="text-center upload-file-box">
																			<div className="text-center upload-file-arrow">
																				<FontAwesomeIcon icon="cloud-arrow-up" />
																				<input id="upload" type="file" onChange={this.uploadFile} style={{display: 'none'}} />
																			</div>
																		</div>
																	</Col>
																	<Col>
																		<div className="upload-file-info">
																			<div className="float-right">
																				{this.state.percent>0&&`${this.state.percent}%`}
																			</div>
																			<div className="">
																				{this.state.filename.length>0?this.state.filename.substring(0,40):`Click to upload file`}
																			</div>
																			<div className="">
																				<ProgressBar animated now={this.state.percent} />
																			</div>
																		</div>
																	</Col>
																</Row>
															</Col>
															<Col xs={12}>
																<Gallery photos={this.state.images} direction={"column"} columns={4} renderImage={this.renderImage} />
															</Col>
														</Row>
													</div>
												</div>

												<div className="form-group row pt-1 pb-0 mb-1">
													<label htmlFor="frequency" className="col-sm-3 col-form-label col-form-label-sm ps-4">
														<strong>Frequency</strong><br />
													</label>
													<div className="col-md-8 mt-2">
														<Form.Control form="edit" as="select" name="frequency" id="frequency" value={this.state.seo_edit.frequency} onChange={this.handleChange}>
															<option>hourly</option>
															<option>daily</option>
															<option>weekly</option>
														</Form.Control>
													</div>
												</div>
												
												<div className="form-group row pt-1 pb-0 mb-1">
													<label htmlFor="priority" className="col-sm-3 col-form-label col-form-label-sm ps-4">
														<strong>Priority</strong><br />
													</label>
													<div className="col-md-8 mt-2">
														<Form.Control form="edit" as="select" name="priority" id="priority" value={this.state.seo_edit.priority} onChange={this.handleChange}>
															<option>0.1</option>
															<option>0.2</option>
															<option>0.3</option>
															<option>0.4</option>
															<option>0.5</option>
															<option>0.6</option>
															<option>0.7</option>
															<option>0.8</option>
															<option>0.9</option>
															<option>1.0</option>
														</Form.Control>
													</div>
												</div>
												
											</Col>
										</Row>
									</div>
									<div className="card-footer">
										<ButtonGroup size="sm">
											<Button onClick={()=>this.editSeo(-1)}>Cancel</Button>
											<Button onClick={(e)=>this.submitEvent(e)}>Save</Button>
										</ButtonGroup>
										&nbsp;&nbsp;&nbsp;{this.state.error}
									</div>
								</Form>
							</>
						:
							<>
								<div className="card-header">
									<h3 className="card-title">mix365.co.uk{this.state.seo[e].location}</h3>
									<div className="card-tools">
										<ButtonGroup size="sm">
											<Button onClick={()=>this.editSeo(this.state.seo[e].id)}>Edit</Button>
											<Button onClick={()=>this.share(this.state.seo[e].location)}>Share</Button>
										</ButtonGroup>
									</div>
								</div>
								<div className="card-body admin-seo">
									<Row className="py-1 gx-0">
										<Col>
											<h3>{this.state.seo[e].title}</h3>
											<Text style={{color: '#ffffff'}}>{this.state.seo[e].description}</Text>
										</Col>
										<Col xs={2} className="px-2">
											<img src={`https://mix365.co.uk${this.state.seo[e].image}`} className="admin-seo-img" />
										</Col>
									</Row>
								</div>
								<div className="card-footer">
									<Row>
										<Col>
											Frequency<br />{this.state.seo[e].changefreq}
										</Col>
										<Col>
											priority<br />{this.state.seo[e].priority}
										</Col>
									</Row>
								</div>
							</>
						}
					</div>
        )
      })
		return (
			<>
				{this.state.status &&
					<Row className="dj-area pt-4 pb-5 px-4">
						<Col xs={12} md={2} className="djarea-sidemenu">
							<DJAreaSideMenu />
						</Col>
						{this.state.status &&
							<Col>
								<Row>
									<Col xs={12}>
										{seo}
									</Col>
									{this.state.edit === -1 &&
										<Col xs={12}>
											<Button onClick={()=>this.editSeo(0)}>Create SEO Entry</Button>
										</Col>
									}
									{this.state.edit === 0 &&
										<Col xs={12}>
											<div className="card bg-dark">
												<Form id="edit" onSubmit={this.submitEvent}>
													<div className="card-header">
														<h3 className="card-title">Create SEO Entry</h3>
														<div className="card-tools">
														</div>
													</div>
													<div className="card-body admin-seo">
														<Row className="py-1 gx-0">
															<Col>

																<div className="form-group row pt-1 pb-0 mb-1">
																	<label htmlFor="url" className="col-sm-3 col-form-label col-form-label-sm ps-4">
																		<strong>URL</strong><br />
																	</label>
																	<div className="col-md-6 mt-2">
																		<Form.Control form="edit" type="text" name="url" id="url" value={this.state.seo_edit.url} onChange={this.handleChange} placeholder="Website Url" />
																		<small>Please exclude the domain name and start from the first forward slash.</small>
																	</div>
																</div>

																<div className="form-group row pt-1 pb-0 mb-1">
																	<label htmlFor="title" className="col-sm-3 col-form-label col-form-label-sm ps-4">
																		<strong>Title</strong><br />
																	</label>
																	<div className="col-md-6 mt-2">
																		<Form.Control form="edit" type="text" name="title" id="title" value={this.state.seo_edit.title} onChange={this.handleChange} placeholder="Website Title" />
																	</div>
																</div>

																<div className="form-group row pt-1 pb-0 mb-1">
																	<label htmlFor="description" className="col-sm-3 col-form-label col-form-label-sm ps-4">
																		<strong>Description</strong><br />
																	</label>
																	<div className="col-md-8 mt-2">
																		<Form.Control form="edit" as="textarea" name="description" id="description" rows={5} value={this.state.seo_edit.description} onChange={this.handleChange} placeholder="Website Description" />
																	</div>
																</div>
																
																<div className="form-group row pt-1 pb-0 mb-1">
																	<label htmlFor="image" className="col-sm-3 col-form-label col-form-label-sm ps-4">
																		<strong>Image</strong><br />
																	</label>
																	<div className="col-md-8 mt-2">
																		<Row>
																			<Col xs={3} className="admin-seo-selected">
																				<img src={`https://mix365.co.uk/images/seo/${this.state.seo_edit.image}`} className="admin-seo-selected-image" alt="No Image Selected" />
																			</Col>
																			<Col xs={9}>
																				<Row onClick={(f)=>this.clickuploadFile(f)} style={{cursor: 'pointer'}}>
																					<Col xs={3} className="upload-file-outer">
																						<div className="text-center upload-file-box">
																							<div className="text-center upload-file-arrow">
																								<FontAwesomeIcon icon="cloud-arrow-up" />
																								<input id="upload" type="file" onChange={this.uploadFile} style={{display: 'none'}} />
																							</div>
																						</div>
																					</Col>
																					<Col>
																						<div className="upload-file-info">
																							<div className="float-right">
																								{this.state.percent>0&&`${this.state.percent}%`}
																							</div>
																							<div className="">
																								{this.state.filename.length>0?this.state.filename.substring(0,40):`Click to upload file`}
																							</div>
																							<div className="">
																								<ProgressBar animated now={this.state.percent} />
																							</div>
																						</div>
																					</Col>
																				</Row>
																			</Col>
																			<Col xs={12}>
																				<Gallery photos={this.state.images} direction={"column"} columns={4} renderImage={this.renderImage} />
																			</Col>
																		</Row>
																	</div>
																</div>

																<div className="form-group row pt-1 pb-0 mb-1">
																	<label htmlFor="frequency" className="col-sm-3 col-form-label col-form-label-sm ps-4">
																		<strong>Frequency</strong><br />
																	</label>
																	<div className="col-md-8 mt-2">
																		<Form.Control form="edit" as="select" name="frequency" id="frequency" value={this.state.seo_edit.frequency} onChange={this.handleChange}>
																			<option>hourly</option>
																			<option>daily</option>
																			<option>weekly</option>
																		</Form.Control>
																	</div>
																</div>
																
																<div className="form-group row pt-1 pb-0 mb-1">
																	<label htmlFor="priority" className="col-sm-3 col-form-label col-form-label-sm ps-4">
																		<strong>Priority</strong><br />
																	</label>
																	<div className="col-md-8 mt-2">
																		<Form.Control form="edit" as="select" name="priority" id="priority" value={this.state.seo_edit.priority} onChange={this.handleChange}>
																			<option>0.1</option>
																			<option>0.2</option>
																			<option>0.3</option>
																			<option>0.4</option>
																			<option>0.5</option>
																			<option>0.6</option>
																			<option>0.7</option>
																			<option>0.8</option>
																			<option>0.9</option>
																			<option>1.0</option>
																		</Form.Control>
																	</div>
																</div>
																
															</Col>
														</Row>
													</div>
													<div className="card-footer">
														<ButtonGroup size="sm">
															<Button onClick={()=>this.editSeo(-1)}>Cancel</Button>
															<Button onClick={(e)=>this.submitEvent(e)}>Save</Button>
														</ButtonGroup>
														&nbsp;&nbsp;&nbsp;{this.state.error}
													</div>
												</Form>
											</div>
										</Col>
									}
								</Row>
							</Col>
						}
					</Row>
					}
				{this.state.share!==false && <Share url={this.state.share} show={this.state.share.length>0} close={this.close} /> }
			</>
		);
	}
}
